import React, { ReactNode, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'

import { TenantDto, useAllTenants, useTenantById } from '../../data/tenants'
import { setCurrentTenantId, setCurrentTenantName, useCurrentTenantId } from '../../utils/tenants'
import Header from './header'
import Navigation from './navigation'

type Props = {
  children?: ReactNode
}

export const AuthenticatedComponent: React.FC<Props> = ({ children }) => {
  const navigate = useNavigate()
  const { data } = useAllTenants()
  const tenantId = useCurrentTenantId()
  const [tenantIds, setTenantIds] = useState<TenantDto[]>()

  const { error } = useTenantById(tenantId as string)

  useEffect(() => {
    if (data) {
      setTenantIds(data)
    }
  }, [data])

  useEffect(() => {
    if (tenantIds?.length === 1) {
      setCurrentTenantId(tenantIds[0].id)
      setCurrentTenantName(tenantIds[0].name)
      navigate('/')
    } else if (error) {
      navigate('/tenants/switch')
    }
  }, [tenantIds, error, navigate])

  return (
    <>
      <Header />
      <div className="wrapper">
        <Navigation />
        <main>
          <div>{children}</div>
          <Outlet />
        </main>
      </div>
    </>
  )
}
